<section tuiContent class="text-left">
	<p
		[innerHtml]="
			context.data.description | transloco: context.data.translationParams
		"
	></p>
</section>

<footer tuiFooter>
	<button size="s" tuiButton appearance="accent" (click)="onAccept()">
		{{ acceptText | transloco: context.data.translationParams }}
	</button>
</footer>
